__turbopack_context__.v({
  "arrowIcon": "StudentTestimonial-module-scss-module__lFubHq__arrowIcon",
  "card": "StudentTestimonial-module-scss-module__lFubHq__card",
  "cta": "StudentTestimonial-module-scss-module__lFubHq__cta",
  "ctaButton": "StudentTestimonial-module-scss-module__lFubHq__ctaButton",
  "darkBottomGradient": "StudentTestimonial-module-scss-module__lFubHq__darkBottomGradient",
  "gradient": "StudentTestimonial-module-scss-module__lFubHq__gradient",
  "grid": "StudentTestimonial-module-scss-module__lFubHq__grid",
  "headTitle": "StudentTestimonial-module-scss-module__lFubHq__headTitle",
  "heading": "StudentTestimonial-module-scss-module__lFubHq__heading",
  "headtext": "StudentTestimonial-module-scss-module__lFubHq__headtext",
  "iconImg": "StudentTestimonial-module-scss-module__lFubHq__iconImg",
  "imageWrapper": "StudentTestimonial-module-scss-module__lFubHq__imageWrapper",
  "noBackground": "StudentTestimonial-module-scss-module__lFubHq__noBackground",
  "para": "StudentTestimonial-module-scss-module__lFubHq__para",
  "slide": "StudentTestimonial-module-scss-module__lFubHq__slide",
  "studentBtn": "StudentTestimonial-module-scss-module__lFubHq__studentBtn",
  "subTitle": "StudentTestimonial-module-scss-module__lFubHq__subTitle",
  "subtitle": "StudentTestimonial-module-scss-module__lFubHq__subtitle",
  "testimonialContainer": "StudentTestimonial-module-scss-module__lFubHq__testimonialContainer",
  "testimonialPlayBtn": "StudentTestimonial-module-scss-module__lFubHq__testimonialPlayBtn",
  "testimonialSection": "StudentTestimonial-module-scss-module__lFubHq__testimonialSection",
  "testimonialSectionSpecific": "StudentTestimonial-module-scss-module__lFubHq__testimonialSectionSpecific",
  "text": "StudentTestimonial-module-scss-module__lFubHq__text",
  "title": "StudentTestimonial-module-scss-module__lFubHq__title",
  "titleNew": "StudentTestimonial-module-scss-module__lFubHq__titleNew",
});
